module.exports = __webpack_public_path__ + "static/img/env26.cd72acd.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/env26.png
// module id = 116
// module chunks = 4